<template>
    <snippet-card
        :modelValue="props.modelValue"
        v-model:nestedModal="nestedModal"
        :blockFiles="props.blockFiles"
        :blockImages="props.blockImages"
        :hasBlockedContent="hasBlockedContent"
    >
        <template v-slot:actions>
            <vx-button @click.prevent="emit('selected')"
                :disabled="hasBlockedContent"
                class="sm:w-auto"
                data-test="select-btn"
                type="button"
                block
                size="md"
                color="primary">
                Select
                <font-awesome-icon widthAuto :icon="faFilePen"></font-awesome-icon>
            </vx-button>
        </template>
    </snippet-card>
</template>

<script setup>
import { faFilePen } from '@fortawesome/pro-solid-svg-icons';
import { VxButton } from '@voxie/frontend-components';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import SnippetCard from '~/components/snippets/components/SnippetCard.vue';
import { computed } from 'vue';
import { hasImage } from '~/utils/message';


const props = defineProps({
    modelValue: {
        type: Object,
        required: true,
    },
    blockImages: {
        type: Boolean,
        default: false,
    },
    blockFiles: {
        type: Boolean,
        default: false,
    },
});

const nestedModal = defineModel('nestedModal', {
    type: Boolean,
    required: false,
    default: false,
});

const emit = defineEmits(['selected']);

const hasBlockedContent = computed(() => {
    if (!props.modelValue.media_content_type && !props.modelValue.media_url) {
        return false;
    }

    const image = hasImage(props.modelValue);

    if (props.blockImages && image) {
        return true;
    }

    return !!(props.blockFiles && !image);
});
</script>
